import { render, staticRenderFns } from "./AssignmentGifts.vue?vue&type=template&id=e6e8e544&scoped=true"
import script from "./AssignmentGifts.vue?vue&type=script&lang=js"
export * from "./AssignmentGifts.vue?vue&type=script&lang=js"
import style0 from "./AssignmentGifts.vue?vue&type=style&index=0&id=e6e8e544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e8e544",
  null
  
)

export default component.exports